"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformGradient = exports.default = void 0;
const transformGradient = gradient => `${gradient.type}-gradient(${gradient.angle}deg, ${gradient.stops[0].color} ${gradient.stops[0].stop * 100}%, ${gradient.stops[1].color} ${gradient.stops[1].stop * 100}%)`;
exports.transformGradient = transformGradient;
var _default = exports.default = {
  transformGradient
};